// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE
'use strict';

var List = require("bs-platform/lib/js/list.js");
var $$Array = require("bs-platform/lib/js/array.js");
var Curry = require("bs-platform/lib/js/curry.js");
var React = require("react");
var Belt_Option = require("bs-platform/lib/js/belt_Option.js");
var Phoneme$Phonics = require("./Phoneme.bs.js");
var Storage$Phonics = require("./Storage.bs.js");
var SavedWords$Phonics = require("./SavedWords.bs.js");

function str(prim) {
  return prim;
}

function reducer(state, action) {
  if (typeof action === "number") {
    if (action !== 0) {
      return {
              word: state.word,
              display: /* DisplayPlay */0
            };
    } else {
      return {
              word: state.word,
              display: /* DisplaySavedWords */1
            };
    }
  } else {
    return {
            word: action[0],
            display: /* DisplayPlay */0
          };
  }
}

function View(Props) {
  var dispatch = Props.dispatch;
  var state = Props.state;
  var onEditButtonClicked = Props.onEditButtonClicked;
  var View$1 = function (Props) {
    var word = Props.word;
    return React.createElement("div", {
                className: "word"
              }, $$Array.of_list(List.mapi((function (index, phoneme) {
                          return React.createElement(Phoneme$Phonics.make, {
                                      phoneme: phoneme,
                                      key: String(index)
                                    });
                        }), word)));
  };
  var View$2 = function (Props) {
    return React.createElement("div", {
                className: "action"
              }, React.createElement("button", {
                    className: "transparent-button load-button",
                    title: "Load",
                    onClick: (function (_evt) {
                        return Curry._1(dispatch, /* LoadButtonClicked */0);
                      })
                  }), React.createElement("button", {
                    className: "transparent-button edit-button",
                    title: "Edit",
                    onClick: (function (_evt) {
                        return Curry._1(onEditButtonClicked, /* () */0);
                      })
                  }));
  };
  var prevButtonClicked = function (_evt) {
    var word = Storage$Phonics.prevWord(state.word);
    return Curry._1(dispatch, /* LoadWord */[word]);
  };
  var shuffleButtonClicked = function (_evt) {
    var word = Belt_Option.getWithDefault(Storage$Phonics.shuffleWord(/* () */0), state.word);
    return Curry._1(dispatch, /* LoadWord */[word]);
  };
  var nextButtonClicked = function (_evt) {
    var word = Storage$Phonics.nextWord(state.word);
    return Curry._1(dispatch, /* LoadWord */[word]);
  };
  var View$3 = function (Props) {
    return React.createElement("div", {
                className: "navigation"
              }, React.createElement("button", {
                    className: "transparent-button prev-button",
                    title: "Next",
                    onClick: prevButtonClicked
                  }), React.createElement("button", {
                    className: "transparent-button shuffle-button",
                    title: "Next",
                    onClick: shuffleButtonClicked
                  }), React.createElement("button", {
                    className: "transparent-button next-button",
                    title: "Next",
                    onClick: nextButtonClicked
                  }));
  };
  var match = state.display;
  if (match) {
    return React.createElement(SavedWords$Phonics.make, {
                onWordClicked: (function (word) {
                    return Curry._1(dispatch, /* LoadWord */[word]);
                  }),
                onCloseClicked: (function (param) {
                    return Curry._1(dispatch, /* CloseSavedWordsClicked */1);
                  })
              });
  } else {
    return React.createElement("div", {
                className: "play"
              }, React.createElement(View$1, {
                    word: state.word
                  }), React.createElement(View$3, { }), React.createElement(View$2, { }));
  }
}

var make = View;

exports.str = str;
exports.reducer = reducer;
exports.make = make;
/* react Not a pure module */
